// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
Main page styles
========================================================================== */
.form-login {
  width: 50%;
  margin: auto;
  background: #f1f1f1;
  border-radius: 10px;
}
.form-login .ant-form {
  padding: 40px;
}
.form-login .forgot {
  cursor: pointer;
  display: flex;
  justify-content: right;
}
.form-login .forgot:hover, .form-login .forgot:active {
  color: var(--bs-blue);
}`, "",{"version":3,"sources":["webpack://./src/main/webapp/app/modules/login/style.scss"],"names":[],"mappings":"AAAA;;4EAAA;AAGA;EACI,UAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;AACJ;AAAI;EACE,aAAA;AAEN;AAAI;EACE,eAAA;EACA,aAAA;EACA,sBAAA;AAEN;AADM;EAEE,qBAAA;AAER","sourcesContent":["/* ==========================================================================\r\nMain page styles\r\n========================================================================== */\r\n.form-login {\r\n    width: 50%;\r\n    margin: auto;\r\n    background: #f1f1f1;\r\n    border-radius: 10px;\r\n    .ant-form {\r\n      padding: 40px;\r\n    }\r\n    .forgot {\r\n      cursor: pointer;\r\n      display: flex;\r\n      justify-content: right;\r\n      &:hover,\r\n      &:active {\r\n        color: var(--bs-blue);\r\n      }\r\n    }\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
